
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const TITLE_SEPARATOR = " · ";

export function useDocumentTitle(title: string | null | undefined) {
  const { t } = useTranslation();
  const brand = t("common.brandName");

  useEffect(() => {
    const desired = !title || title === brand ? brand : `${title}${TITLE_SEPARATOR}${brand}`;
    const apply = () => {
      if (document.title !== desired) document.title = desired;
    };
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(document.head, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [brand, title]);
}
